import { z } from "zod";

/** `{ id, name, region }` as returned by the cities lookup, expert profiles, and listing cards. */
export const CitySchema = z.object({
    id: z.number().int(),
    name: z.string(),
    region: z.string().nullable().optional(),
});

/** Rows of the cross-country `GET /cities?ids=` lookup carry the ISO2 country. */
export const CityWithCountrySchema = CitySchema.extend({
    country: z.string(),
});

export const CitiesSchema = z.array(CitySchema);

export type City = z.infer<typeof CitySchema>;
export type CityWithCountry = z.infer<typeof CityWithCountrySchema>;
